import React, { useState } from "react";
import AppText from "./AppText";
import Button from "../../presentational/Button";
import AddPasskey from "./AddPasskey";
import AddTotp from "./AddTotp";
import Links from "./Links";

interface EnableMfaProps {
    serverError: string;
    isLoading: boolean;
    allowSnooze: boolean;
    totpKey?: string;
    totpQrCodeUri?: string;
    snooze2FA: () => void;
    enableTotp: (totpKey: string, code: string) => void;
    passkeysEnabled: boolean;
    addPasskey?: () => void;
}

const EnableMfa: React.FC<EnableMfaProps> = ({
    serverError,
    isLoading,
    allowSnooze,
    totpKey,
    totpQrCodeUri,
    snooze2FA,
    enableTotp,
    passkeysEnabled,
    addPasskey,
}) => {
    const [showTotp, setShowTotp] = useState(!passkeysEnabled);

    const toggleTotp = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        setShowTotp(!showTotp);
        return false;
    };

    const handleSnooze = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        snooze2FA();
        return false;
    };

    return (
        <main>
            <div className="form-wrapper">
                <form className="form">
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="form-header">
                        <img className="form-header-logo" src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-blue-bug-logo-centered.svg" alt="MyDataHelps Designer Logo" />
                        <h2>
                            <AppText textKey="enable-mfa-title" />
                        </h2>
                        <p>
                            <AppText textKey="enable-mfa-info" />
                        </p>
                    </div>
                    {passkeysEnabled && !showTotp && addPasskey && (
                        <>
                            <div>
                                <p>
                                    <strong>
                                        <AppText textKey="passkey-title" />
                                    </strong>
                                </p>
                                <p>
                                    <AppText textKey="passkey-info" />
                                </p>
                            </div>
                            <AddPasskey
                                isSubView={true}
                                serverError={serverError}
                                isLoading={isLoading}
                                addPasskey={addPasskey}
                            />
                        </>
                    )}
                    {showTotp && totpKey && totpQrCodeUri && (
                        <>
                            <div>
                                <p>
                                    <strong>
                                        <AppText textKey="totp-title" />
                                    </strong>
                                </p>
                                <p>
                                    <AppText textKey="totp-info" />
                                </p>
                            </div>
                            <AddTotp
                                isSubView={true}
                                serverError={serverError}
                                isLoading={isLoading}
                                totpKey={totpKey!}
                                totpQrCodeUri={totpQrCodeUri!}
                                enableTotp={enableTotp}
                            />
                        </>
                    )}
                    {passkeysEnabled && !showTotp && totpKey && totpQrCodeUri && (
                        <Button onClick={toggleTotp} type="button">
                            <AppText textKey="enable-mfa-use-topt-label" />
                        </Button>
                    )}
                    {passkeysEnabled && showTotp && addPasskey && (
                        <Button onClick={toggleTotp} className="minimal-button editor-controls-button" type="button">
                            <AppText textKey="enable-mfa-use-passkey-label" />
                        </Button>
                    )}
                    {allowSnooze && (
                        <Button onClick={handleSnooze} type="button">
                            <AppText textKey="enable-mfa-snooze-label" />
                        </Button>
                    )}
                </form>
                <Links />
            </div>
        </main>
    );
};

export default EnableMfa;
